import { cn } from '@/lib/utils'

/** Sprint "Product Experience V2" (10/09/2026): primitivo de Design System reutilizable --
 * pestañas tipo píldora, mismo lenguaje visual en toda la Mini App (Top IA/Más Seguros/
 * Secundarios en Picks; Conservador/Balanceado/Agresivo/SGP en Parlays; Resumen/Estrategias/
 * Análisis/Inteligencia en Mi Evolución) en vez de que cada pantalla reinvente su propio
 * selector. Cada pestaña puede llevar un contador real (nunca inventado) para que la
 * primera lectura -- "¿cuánto hay aquí?" -- no dependa de abrir la pestaña. */
export interface PillTabItem {
  key: string
  label: string
  count?: number
}

export function PillTabs({
  items, active, onChange,
}: { items: PillTabItem[]; active: string; onChange: (key: string) => void }) {
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto no-scrollbar -mx-1 px-1 pb-0.5">
      {items.map((item) => {
        const isActive = item.key === active
        return (
          <button
            key={item.key}
            onClick={() => onChange(item.key)}
            className={cn(
              'shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-xs font-bold transition-colors',
              isActive
                ? 'bg-brand text-black'
                : 'bg-panel-elevated border border-border text-text-muted hover:text-text hover:border-text-dim/40',
            )}
          >
            <span>{item.label}</span>
            {item.count != null && (
              <span
                className={cn(
                  'figure text-[10px] font-bold rounded-full px-1.5 py-0.5 leading-none',
                  isActive ? 'bg-black/15 text-black' : 'bg-panel text-text-dim',
                )}
              >
                {item.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
